module.exports = __webpack_public_path__ + "static/media/logo.ed862055.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 585
// module chunks = 0